import { Component, inject } from '@angular/core';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  standalone: true,
  template: `
    <p class="min-w-[280px] overflow-x-hidden text-ellipsis" [style.maxWidth]="maxWidth">
      {{ ref.data.message }}
    </p>
  `,
})
export class ConfirmationModalComponent {
  readonly ref = inject(CustomOverlayRef);

  get maxWidth(): string {
    return this.ref.data.maxWidth ? `${this.ref.data.maxWidth}px` : '520px';
  }
}
